export const EVENT = 'eventTypeId';
export const APPLICATION = 'appId';
export const BUSINESS_PARTNERS = 'businessPartnerIds';
export const TRAFFIC = 'trafficTypeId';

export const ACTIVITY_TYPE_TOTAL = 1;
export const ACTIVITY_TYPE = 'activityTypeId';
export const TRAFFIC_TO_BUSINESS_PARTNER = 0;
export const TRAFFIC_TO_AFFILIATES = 2;
export const AFFILIATES = 'affiliateIds';
export const REGISTRATION_COUNTRIES = 'regActionCountryIds';
export const EVENT_COUNTRIES = 'eventCountryIds';

export const STRATEGIES = 'strategies';
export const IS_FINAL = 'isFinal';
export const REQUEST_URL = 'requestUrlTemplate';

export const CONDITIONS = 'conditions';
export const TARGET = 'targetPropertyId';
export const ENTITIES = 'values';

export const IS_ACTIVE = 'enabled';

export const INCLUDE_REJECTED_REGS = 'includeRejected';

export const TARGET_APPLICATION = 0;
export const TARGET_PLATFORM = 2;
export const TARGET_NETWORK = 3;
export const TARGET_CLUSTER = 4;
export const TARGET_REGISTRATION_PLATFORM = 5;

export const DEPENDENCIES = {
  [AFFILIATES]: [BUSINESS_PARTNERS],
};
